module.exports = __webpack_public_path__ + "static/media/hf_inferior.85f2df54.jpg";